import { useDeleteFileMutation } from "apollo/hooks/mutations";
import { useGetFilesLazyQuery } from "apollo/hooks/queries";
import {
  FILE_SCOPE,
  FILE_SHARE_MODE_NONE,
  RECARE_FILE_TYPE,
  REHAB_FORM_SUB_TYPES,
  REHAB_FORM_TYPES,
} from "core/consts";
import { getErrorMessage } from "core/model/utils/errors";
import {
  Auction,
  RecareFileType,
  RehabFormSubType,
  RehabFormType,
} from "core/types";

export const useDeleteUnsharedFileByType = ({
  auctionId,
  formSubType,
  formType,
}: {
  auctionId: Auction["id"];
  formType?: RehabFormType;
  formSubType?: RehabFormSubType;
}) => {
  const params =
    `auction_id=${auctionId}&scope=${FILE_SCOPE.PATIENT_FILES}` as const;
  const [getFilesLazy] = useGetFilesLazyQuery({ params });

  const [deleteBEFile] = useDeleteFileMutation({});

  let recareFileType: RecareFileType;
  if (formSubType === REHAB_FORM_SUB_TYPES.DRV && formType) {
    recareFileType =
      formType === REHAB_FORM_TYPES.GENERAL
        ? RECARE_FILE_TYPE.DRV_GENERAL_FORM
        : RECARE_FILE_TYPE.DRV_MEDICAL_FORM;
  } else if (formSubType === REHAB_FORM_SUB_TYPES.GKV && formType) {
    recareFileType =
      formType === REHAB_FORM_TYPES.GENERAL
        ? RECARE_FILE_TYPE.GKV_GENERAL_FORM
        : RECARE_FILE_TYPE.GKV_MEDICAL_FORM;
  } else {
    recareFileType = RECARE_FILE_TYPE.TRANSITIONAL_CARE;
  }

  const deleteUnsharedFile = async () => {
    const { data } = await getFilesLazy({ params });
    const files = data?.files;

    const matchingFile = files?.find(
      ({ recare_file_type, share_mode }) =>
        recare_file_type === recareFileType &&
        share_mode === FILE_SHARE_MODE_NONE,
    );

    if (matchingFile) {
      try {
        await deleteBEFile(undefined, {
          id: matchingFile.id,
          params,
        });
      } catch (fileDeleteErr) {
        console.error(
          `Error deleting backend file: ${getErrorMessage(fileDeleteErr)}`,
        );
      }
    }
  };

  return { deleteUnsharedFile };
};
